(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('loginForm', loginForm);

    /* @ngInject */
    function loginForm() {
        var directive = {
            bindToController: true,
            templateUrl: 'login-form.tpl',
            controller: loginFormController,
            controllerAs: 'vm',
            link: link,
            restrict: 'C',
            scope: {
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.vm.loginTab =  scope.$root.stats.loginFormOptions.tab;
            scope.vm.submitting = false;
        }
    }
    /* @ngInject */
    function loginFormController ($scope,$http,$location,$route) {  //we survived as best we could :)
        $scope.switchTab = function(tab) {
            $scope.vm.submitting = false;
            $scope.vm.loginTab = tab;
        };

        $scope.vm.action = function(e) {
            var form = angular.element(e.currentTarget).closest('form');
            var errors = '';
            form.find(':input').each(function(i, e) {
                if ((e.value.trim() == '') && (e.hasAttribute('required'))) {
                    errors += 'Field "' + e.getAttribute('name').replace('user_', '') + '" is required <br>';
                }
            });

            if (errors != '') {
                angular.element(e.currentTarget).siblings('p').html(errors).addClass('error');
                return false;
            } else {
                var action = form.data('action');
                $scope.vm.ajaxIt(action, form.serialize(),e);
            }
        };

        $scope.vm.ajaxIt = function(method,data,e) {
            var adata = {
                action: 'pie_action',
                method: method,
                nonce: $scope.$root.stats.nonce,
                params: data
            };
            $scope.vm.submitting = true;
            $http.post(ajaxurl, adata).then(function(response) {
                if (angular.isDefined(response.data.message)) {
                    angular.element(e.currentTarget).siblings('p').text(response.data.message);
                }

                if (response.data.result) {
                    if (angular.isDefined(response.data.switchTo)) {
                        $scope.vm.loginTab = response.data.switchTo;
                    } else if (angular.isDefined(response.data.redirectUrl)) {
                        if ($location.url() == response.data.redirectUrl) {
                            $route.reload();
                        } else {
                            $location.url(response.data.redirectUrl);
                        }
                        angular.element('.overlay.active').find('form')[0].reset();
                        angular.element('.overlay.active').removeClass('active');
                        $scope.$root.modalContent = '';
                    }
                } else {
                    if (angular.isDefined(response.data.reload)) {
                        $route.reload();
                    } else {
                        angular.element(e.currentTarget).siblings('p').addClass('error');
                    }
                }
                if (!((method == 'sign_up') && (response.data.result))) {
                    $scope.vm.submitting = false;
                }
            });

        };

    }
})();